import React from "react";

export function useContextOrThrow<T>(context: React.Context<T>) {
	const result = React.useContext(context);
	if (result === undefined) {
		throw new Error("Context not found");
	}
	return result;
}